import { useState, useEffect, useRef } from "react";
import Globe from "react-globe.gl";
import * as THREE from "three";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getArtikel } from "../artikel/service";
import ConsultationModal from "../../components/commons/consultation/ConsultationModal";
import IASBadge from "./icef_batch";

// ============================================================
// KONSTANTA & DATA STATIS
// ============================================================

export function getExperienceYears(startDate = new Date(2010, 2, 1)) {
  const today = new Date();

  let years = today.getFullYear() - startDate.getFullYear();
  const anniversary = new Date(
    today.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  );

  if (today < anniversary) {
    years -= 1;
  }

  return years;
}

const experienceYears = getExperienceYears();

/** ISO numeric code negara-negara tujuan studi */
const TARGET_ISO_SET = new Set([
  "036", "124", "616", "410", "392", "840",
  "792", "554", "276", "826", "250", "380",
  "724", "528", "756", "372", "208", "246",
  "352", "702", "458", "360", "348", "156"
]);

/** Daftar negara beserta koordinat untuk interaksi globe */
const COUNTRY_MAP = [
  { isoNum: "036", label: "Australia", slug: "aus", lat: -25.27, lng: 133.77 },
  { isoNum: "372", label: "Ireland", slug: "irl", lat: 53.14, lng: -7.69 },
  { isoNum: "124", label: "Canada", slug: "can", lat: 56.13, lng: -106.35 },
  { isoNum: "616", label: "Poland", slug: "pol", lat: 52.24, lng: 21.02 },
  { isoNum: "348", label: "Hungary", slug: "hun", lat: 47.16, lng: 19.50 },
  { isoNum: "410", label: "Korea", slug: "kor", lat: 36.5, lng: 127.5 },
  { isoNum: "554", label: "New Zealand", slug: "nzl", lat: -40.90, lng: 174.89 },
  { isoNum: "360", label: "Indonesia", slug: "idn", lat: -2.55, lng: 118.01 },
  { isoNum: "458", label: "Malaysia", slug: "mys", lat: 4.21, lng: 101.97 },
  { isoNum: "702", label: "Singapore", slug: "sgp", lat: 1.35, lng: 103.82 },
  { isoNum: "392", label: "Japan", slug: "jpn", lat: 36.20, lng: 138.25 },
  { isoNum: "156", label: "China", slug: "chn", lat: 35.86, lng: 104.19 },
  { isoNum: "792", label: "Turkey", slug: "tur", lat: 38.96, lng: 35.24 },
  { isoNum: "840", label: "United States", slug: "usa", lat: 39.83, lng: -98.58 },
  { isoNum: "276", label: "Germany", slug: "deu", lat: 51.16, lng: 10.45 },
  { isoNum: "250", label: "France", slug: "fra", lat: 46.23, lng: 2.21 },
  { isoNum: "528", label: "Netherlands", slug: "nld", lat: 52.13, lng: 5.29 },
  { isoNum: "724", label: "Spain", slug: "esp", lat: 40.46, lng: -3.75 },
  { isoNum: "826", label: "United Kingdom", slug: "gbr", lat: 55.37, lng: -3.43 },
  { isoNum: "208", label: "Denmark", slug: "dnk", lat: 56.26, lng: 9.50 },
  { isoNum: "756", label: "Switzerland", slug: "che", lat: 46.82, lng: 8.23 },
  { isoNum: "246", label: "Finland", slug: "fin", lat: 61.92, lng: 25.75 },
];

/** Data program layanan utama */
const CARD_HERO_DATA = [
  {
    cardTitle: "Study Abroad",
    category: "Program Unggulan",
    description:
      "Wujudkan impian belajar di universitas terbaik dunia. Kami dampingi dari pemilihan kampus, beasiswa, hingga keberangkatan.",
    img: "assets/img/slide/home/f1.webp",
    ctaLabel: "Jelajahi Program",
    ctaLink: "https://superstudent.niecindonesia.com/",
  },
  {
    cardTitle: "J1 Internship USA",
    category: "Magang Internasional",
    description:
      "Dapatkan pengalaman kerja nyata di perusahaan Amerika Serikat dengan visa J1 resmi. Tingkatkan nilai diri di pasar global.",
    img: "assets/img/slide/home/f2.webp",
    ctaLabel: "Cek Peluang Magang",
    ctaLink: "http://internship.niecindonesia.com/",
  },
  {
    cardTitle: "English Course",
    category: "Persiapan Bahasa",
    description:
      "Kuasai IELTS, TOEFL, dan English komunikasi profesional bersama instruktur berpengalaman untuk studi luar negeri.",
    img: "assets/img/slide/home/f3.webp",
    ctaLabel: "Mulai Belajar",
    ctaLink: "http://kursusbahasa.niecindonesia.com/",
  },
  {
    cardTitle: "Edu Trip",
    category: "Wisata Edukasi",
    description:
      "Kenalkan dunia pada generasi muda melalui perjalanan edukatif ke kampus & institusi bergengsi di luar negeri.",
    img: "assets/img/slide/home/f4.webp",
    ctaLabel: "Lihat Destinasi",
    ctaLink: "http://studytour.niecindonesia.com/",
  },
  {
    cardTitle: "Event",
    category: "Acara & Pameran",
    description:
      "Ikuti education fair, seminar, dan workshop eksklusif bersama ratusan universitas dari 20+ negara setiap tahunnya.",
    img: "assets/img/slide/home/f5.webp",
    ctaLabel: "Lihat Event",
    ctaLink: "http://edufest.niecindonesia.com/",
  },
];

/** Statistik kredibilitas */
const CREDIBLE_STATS = [
  { title: <span>{experienceYears}<sup>+</sup></span>, subTitle: "Pengalaman Terpercaya" },
  { title: <span>20+</span>, subTitle: "Negara Tujuan" },
  { title: <span>300+</span>, subTitle: "Pilihan Universitas" },
  { title: <span>10.000+</span>, subTitle: "Program & Jurusan" },
];

/** Alasan memilih NIEC */
const WHY_CHOOSE_US = [
  {
    icon: "bi bi-info-circle",
    title: ["Informasi", "Akurat &", "Terpercaya"],
    body: "NIEC memberikan informasi pendidikan dan visa yang lengkap dan akurat, membantu student membuat keputusan yang tepat.",
  },
  {
    icon: "bi bi-lightning-charge",
    title: ["Proses Mudah", "& Efisien", ""],
    body: "Kami menyederhanakan proses pendaftaran kuliah dan visa dengan sistem yang efisien dan transparan.",
  },
  {
    icon: "bi bi-people",
    title: ["Jaringan Luas &", "Direct Partner", "Resmi"],
    body: "Penghubung langsung antara student dan institusi pendidikan luar negeri dengan partner resmi di 20+ negara.",
  },
  {
    icon: "bi bi-mortarboard",
    title: ["Pendampingan &", "Pengembangan", "Karier"],
    body: "Fokus pada pengembangan diri dan karier mahasiswa melalui bimbingan, pelatihan, dan peluang kerja global.",
  },
];

/** Data testimoni alumni */
const TESTIMONIALS = [
  {
    name: "I Gusti Ayu Agung Rania Laksita Maheswari",
    photo: "assets/img/slide/home/profil-1.webp",
    institution: "De Montfort University",
    location: "UK",
    text: "Proses kuliah ke luar negeri bersama NIEC Indonesia sangat smooth, mulai dari pendaftaran kampus, visa, akomodasi semuanya dibantu secara detail.",
  },
  {
    name: "Kartika Stiady",
    photo: "assets/img/slide/home/profil-2.webp",
    institution: "University of Western Australia",
    location: "Australia",
    text: "Mimpi saya untuk kuliah di salah satu Go8 Australia akhirnya terwujud. Terima kasih kepada NIEC Indonesia yang membantu saya mendapatkan beasiswa dari UWA.",
  },
  {
    name: "Benedicta Shanelle Calantha",
    photo: "assets/img/slide/home/profil-3.webp",
    institution: "Hotel Institute Montreux (HIM), Business School",
    location: "Switzerland",
    text: "Dengan tekad untuk menempuh studi Business dan Hospitality di Swiss, saya kini menjadi bagian dari Hotel Institute Montreux (HIM) - institusi bergengsi peringkat #7 QS World Ranking, berkat dukungan NIEC Indonesia.",
  },
  {
    name: "Maclaren Juchelin",
    photo: "assets/img/slide/home/profil-4.webp",
    institution: "Woosong University",
    location: "Korea",
    text: "Terima kasih kepada NIEC Indonesia yang sudah membantu saya mendapatkan Tuition Scholarship dari Woosong Univerty, Korea Selatan. Semua proses aplikasi, essay, latihan interview dibantu secara maksimal.",
  },
];

/** Benefit kelas STARTS */
const STARTS_BENEFITS = [
  "Exclusive 1 on 1 Mentorship",
  "List 101 Beasiswa Kuliah Luar Negeri",
  "Test Psikologi Minat Bakat",
  "Akses 12 Seri Master Class untuk Softskill Training + Sertifikat",
  "NIEC Alumni Network di 20 negara & 300 universitas",
  "Diskon Khusus Translate & English Course",
  "Prioritas Akses ke event NIEC INDONESIA",
  "Merchandise Exclusive *t&c apply",
  "Kesempatan Gratis Tiket Pesawat ke Negara manapun",
];

// ============================================================
// HELPER
// ============================================================

export const truncateTextFromHtml = (html, maxLength = 150) => {
  const tempEl = document.createElement("div");
  tempEl.innerHTML = html;
  const plainText = tempEl.textContent || tempEl.innerText || "";
  return plainText.length > maxLength
    ? plainText.substring(0, maxLength) + "..."
    : plainText;
};

const getIsoId = (polygon) => String(polygon.id).padStart(3, "0");

// ============================================================
// SUB-KOMPONEN
// ============================================================

const WhyCard = ({ icon, title, body, index }) => (
  <div className="card-why-modern">
    <div className="why-icon-circle">
      <i className={icon} />
    </div>
    <div className="why-content-modern">
      <h5 className="why-title-modern">
        {title.filter(Boolean).join(" ")}
      </h5>
      <p className="why-text-modern">{body}</p>
    </div>
    <div className="why-card-footer">
      <span className="footer-line"></span>
    </div>
  </div>
);

// ============================================================
// HOOK CUSTOM: useWindowSize
// ============================================================

const useWindowSize = () => {
  const [size, setSize] = useState({
    isMobile: window.innerWidth < 768,
    isDesktop: window.innerWidth >= 768,
  });

  useEffect(() => {
    const handleResize = () =>
      setSize({
        isMobile: window.innerWidth < 768,
        isDesktop: window.innerWidth >= 768,
      });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
};

// ============================================================
// HOOK CUSTOM: useGlobe
// ============================================================

const useGlobe = () => {
  const globeRef = useRef();
  const cloudsAddedRef = useRef(false);
  const cloudsMeshRef = useRef(null);
  const [polygonData, setPolygonData] = useState([]);
  const [hoverPolygon, setHoverPolygon] = useState(null);
  const [activeCountry, setActiveCountry] = useState(COUNTRY_MAP[0]);

  useEffect(() => {
    const loadTopoJsonScript = () =>
      new Promise((resolve, reject) => {
        if (window.topojson) { resolve(); return; }
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/topojson-client@3/dist/topojson-client.min.js";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

    loadTopoJsonScript()
      .then(() => fetch("https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json"))
      .then((res) => res.json())
      .then((world) => {
        const features = window.topojson.feature(world, world.objects.countries).features;
        setPolygonData(features);
      })
      .catch((err) => console.warn("Gagal memuat data polygon globe:", err));
  }, []);

  useEffect(() => {
    if (!globeRef.current || !activeCountry) return;
    globeRef.current.pointOfView(
      { lat: activeCountry.lat, lng: activeCountry.lng, altitude: 1.8 },
      1500
    );
  }, [activeCountry]);

  const getPolygonCapColor = (polygon) => {
    const id = getIsoId(polygon);
    if (activeCountry?.isoNum === id) return "rgba(255,255,255,1)";
    if (hoverPolygon === polygon)
      return TARGET_ISO_SET.has(id) ? "rgba(255,255,255,0.85)" : "rgba(255,255,255,0.35)";
    if (TARGET_ISO_SET.has(id)) return "rgba(255,255,255,0.55)";
    return "rgba(255,255,255,0.08)";
  };

  const getPolygonSideColor = (polygon) => {
    const id = getIsoId(polygon);
    if (activeCountry?.isoNum === id) return "rgba(255,255,255,0.5)";
    if (hoverPolygon === polygon)
      return TARGET_ISO_SET.has(id) ? "rgba(255,255,255,0.35)" : "rgba(255,255,255,0.05)";
    if (TARGET_ISO_SET.has(id)) return "rgba(255,255,255,0.2)";
    return "rgba(255,255,255,0.02)";
  };

  const getPolygonStrokeColor = (polygon) => {
    const id = getIsoId(polygon);
    if (activeCountry?.isoNum === id) return "rgba(255, 0, 0, 0.9)";
    if (hoverPolygon === polygon)
      return TARGET_ISO_SET.has(id) ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.2)";
    if (TARGET_ISO_SET.has(id)) return "rgba(255,255,255,0.4)";
    return "rgba(255,255,255,0.1)";
  };

  const getPolygonAltitude = (polygon) => {
    const id = getIsoId(polygon);
    if (activeCountry?.isoNum === id) return 0.045;
    if (TARGET_ISO_SET.has(id)) return 0.015;
    return 0.003;
  };

  const getPolygonLabel = (polygon) => {
    const id = getIsoId(polygon);
    const country = COUNTRY_MAP.find((c) => c.isoNum === id);
    if (!country) return "";
    const isActive = activeCountry?.isoNum === id;
    const border = isActive
      ? "1px solid rgba(255,255,255,0.95)"
      : "1px solid rgba(255, 255, 255, 0.7)";
    return `<div style="background:rgba(20,8,8,0.65);color:#fff;padding:4px 12px;border-radius:16px;font-size:12px;font-weight:600;border:${border};">${country.label}</div>`;
  };

  const handleGlobeReady = () => {
    const globe = globeRef.current;
    if (!globe) return;
    try {
      const controls = globe.controls();
      controls.autoRotate = true;
      controls.autoRotateSpeed = 0.3;
      controls.enableZoom = false;
      controls.enablePan = false;

      globe.pointOfView(
        activeCountry
          ? { lat: activeCountry.lat, lng: activeCountry.lng, altitude: 1.8 }
          : { lat: 10, lng: 120, altitude: 1.8 }
      );

      const scene = globe.scene();
      if (scene) {
        scene.traverse((obj) => {
          if (obj.isMesh && obj.geometry?.type === "SphereGeometry") {
            const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
            mats.forEach((m) => {
              if (m) {
                m.transparent = true;
                m.opacity = 0;
                m.depthWrite = false;
                m.needsUpdate = true;
              }
            });
          }
        });

        if (!cloudsAddedRef.current) {
          cloudsAddedRef.current = true;
          const CLOUDS_URL = "https://unpkg.com/three-globe/example/clouds/clouds.png";
          const CLOUDS_ALTITUDE = 0.003;
          const CLOUDS_ROTATION_SPEED = -0.003;
          const globeRadius = typeof globe.getGlobeRadius === "function"
            ? globe.getGlobeRadius()
            : 1;

          new THREE.TextureLoader().load(CLOUDS_URL, (texture) => {
            const cloudsMesh = new THREE.Mesh(
              new THREE.SphereGeometry(globeRadius * (1 + CLOUDS_ALTITUDE), 60, 60),
              new THREE.MeshPhongMaterial({
                map: texture,
                transparent: true,
                opacity: 0.25,
                depthWrite: false,
              })
            );
            cloudsMesh.renderOrder = 2;
            cloudsMeshRef.current = cloudsMesh;
            scene.add(cloudsMesh);

            const animateClouds = () => {
              if (cloudsMeshRef.current) {
                cloudsMeshRef.current.rotation.y += (CLOUDS_ROTATION_SPEED * Math.PI) / 180;
              }
              requestAnimationFrame(animateClouds);
            };
            animateClouds();
          });
        }
      }
    } catch (err) {
      console.warn("Inisialisasi globe gagal:", err);
    }
  };

  const handlePolygonClick = (polygon) => {
    const id = getIsoId(polygon);
    const matched = COUNTRY_MAP.find((c) => c.isoNum === id);
    if (matched) setActiveCountry(matched);
  };

  return {
    globeRef,
    polygonData,
    hoverPolygon,
    setHoverPolygon,
    activeCountry,
    setActiveCountry,
    getPolygonCapColor,
    getPolygonSideColor,
    getPolygonStrokeColor,
    getPolygonAltitude,
    getPolygonLabel,
    handleGlobeReady,
    handlePolygonClick,
  };
};

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="testi-nav-btn next" onClick={onClick}>
      <i className="bi bi-arrow-right" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="testi-nav-btn prev" onClick={onClick}>
      <i className="bi bi-arrow-left" />
    </div>
  );
};

// ============================================================
// KOMPONEN UTAMA: Home
// ============================================================

const Home = () => {
  const { isMobile, isDesktop } = useWindowSize();
  const globe = useGlobe();
  const [dataArtikel, setDataArtikel] = useState([]);
  const [showAllCountries, setShowAllCountries] = useState(false);
  const [open, setOpen] = useState(false);
  const defaultCount = isDesktop ? 6 : 6;
  const defaultCountries = COUNTRY_MAP.slice(0, defaultCount);
  const collapsibleCountries = COUNTRY_MAP.slice(defaultCount);

  const testimonialSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // ---- FIX: artTrackRef, artActiveRef, scrollToCard dipindah ke Home ----
  const artTrackRef = useRef(null);
  const artActiveRef = useRef(0);

  const scrollToCard = (idx) => {
    const wrap = artTrackRef.current;
    if (!wrap) return;
    const CARD_W = 370;
    const clamped = Math.max(0, Math.min(dataArtikel.length - 1, idx));
    wrap.scrollTo({ left: clamped * CARD_W, behavior: "smooth" });
    artActiveRef.current = clamped;
  };
  // -----------------------------------------------------------------------

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = await getArtikel();
        setDataArtikel(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Gagal memuat artikel:", error);
        setDataArtikel([]);
      }
    };
    fetchArticles();
  }, []);

  // ---- FIX: useEffect drag-to-scroll artikel dipindah ke Home ----
  useEffect(() => {
    const wrap = artTrackRef.current;
    if (!wrap) return;

    const CARD_W = 370;
    let isDragging = false, startX = 0, startScroll = 0;

    const onMouseDown = (e) => {
      isDragging = true;
      startX = e.pageX;
      startScroll = wrap.scrollLeft;
      wrap.classList.add("is-dragging");
    };
    const onMouseUp = () => {
      if (!isDragging) return;
      isDragging = false;
      wrap.classList.remove("is-dragging");
      const idx = Math.round(wrap.scrollLeft / CARD_W);
      scrollToCard(idx);
    };
    const onMouseMove = (e) => {
      if (!isDragging) return;
      wrap.scrollLeft = startScroll - (e.pageX - startX);
    };

    const onScroll = () => {
      if (!wrap) return;
      const idx = Math.round(wrap.scrollLeft / CARD_W);
      const maxScroll = wrap.scrollWidth - wrap.clientWidth;
      const pct = maxScroll > 0 ? (wrap.scrollLeft / maxScroll) * 100 : 0;

      // Update progress fill
      const dotFill = document.getElementById("artDotFill");
      if (dotFill) dotFill.style.width = pct + "%";

      // Loop highlights across 5 dots (modulo logic)
      const dotIndex = idx % 5;
      const dots = document.querySelectorAll(".art-dot");
      dots.forEach((d, i) => d.classList.toggle("active", i === dotIndex));

      const btnPrev = document.getElementById("artBtnPrev");
      const btnNext = document.getElementById("artBtnNext");
      if (btnPrev) btnPrev.disabled = idx === 0;
      if (btnNext) btnNext.disabled = idx >= dataArtikel.length - 1;

      artActiveRef.current = idx;
    };

    wrap.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("mousemove", onMouseMove);
    wrap.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      wrap.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
      wrap.removeEventListener("scroll", onScroll);
    };
  }, [dataArtikel]);
  // ----------------------------------------------------------------

  // Parallax scroll untuk prog-bg
  useEffect(() => {
    const handleScroll = () => {
      document.querySelectorAll(".prog-bg").forEach((bg) => {
        const sec = bg.closest(".prog-section");
        if (!sec) return;
        const rect = sec.getBoundingClientRect();
        const vh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        const progress = (vh - rect.top) / (vh + rect.height);
        const shift = (progress - 0.5) * 80;
        bg.style.transform = `translateY(${shift}px)`;
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Drag-to-scroll untuk card programs track
  useEffect(() => {
    const wrapper = document.querySelector(".card-programs-track-wrapper");
    if (!wrapper) return;
    let isDown = false;
    let startX, scrollLeft;

    const onMouseDown = (e) => {
      isDown = true;
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    };
    const onMouseLeave = () => { isDown = false; };
    const onMouseUp = () => { isDown = false; };
    const onMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      wrapper.scrollLeft = scrollLeft - (x - startX) * 1.5;
    };

    const onScroll = () => {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      const pct = maxScroll > 0 ? (wrapper.scrollLeft / maxScroll) * 100 : 0;
      const fill = document.getElementById("cpProgFill");
      if (fill) fill.style.width = pct + "%";
    };

    wrapper.addEventListener("mousedown", onMouseDown);
    wrapper.addEventListener("mouseleave", onMouseLeave);
    wrapper.addEventListener("mouseup", onMouseUp);
    wrapper.addEventListener("mousemove", onMouseMove);
    wrapper.addEventListener("scroll", onScroll, { passive: true });

    // Initial check
    onScroll();

    return () => {
      wrapper.removeEventListener("mousedown", onMouseDown);
      wrapper.removeEventListener("mouseleave", onMouseLeave);
      wrapper.removeEventListener("mouseup", onMouseUp);
      wrapper.removeEventListener("mousemove", onMouseMove);
      wrapper.removeEventListener("scroll", onScroll);
    };
  }, []);

  const globeSize = isMobile ? 300 : 450;

  return (
    <div className="overflow-hidden">
      <main id="main" className="position-relative">
        {/* ================================================ */}
        {/* SECTION: Hero Banner                             */}
        {/* ================================================ */}
        <section className="hero-section-new">
          <div className="hero-bg-overlay" />
          <div className="container position-relative z-index-2">
            <div className="row text-white hero-content-row align-items-center">

              <div className="col-lg-7 hero-caption-col text-center text-lg-start">
                {/* <div className="hero-badge-wrap mb-4 animate__animated animate__fadeInDown">
                  <span className="badge-glow-dot" />
                  Edisi Beasiswa 2026 Kini Dibuka
                </div> */}
                <h1 className="hero-main-title animate__animated animate__fadeInUp">
                  Mulai Perjalanan <br />
                  <span className="title-accent-wrap">
                    Kuliah & Karirmu
                    <img src="assets/img/slide/home/strip-2.webp" alt="strip" className="title-strip-img" />
                  </span> <br />
                  Ke Luar Negeri
                </h1>

                <p className="hero-main-subtitle mt-4 animate__animated animate__fadeInUp animate__delay-1s">
                  Konsultasi <strong>GRATIS</strong> — Dapatkan rekomendasi kampus terbaik & program magang internasional dengan pendampingan 100% hingga berangkat.
                </p>

                <div className="globe-responsive-wrapper animate__animated animate__zoomIn animate__delay-1s">
                  <div className="plane"></div>
                  <div className="landmark"></div>
                  <div className="mortarboard"></div>
                  <div
                    className="hero-globe-wrapper"
                    style={{
                      position: "relative",
                      width: globeSize,
                      height: globeSize,
                    }}
                  >
                    <div className="globe-aura" />
                    <div className="globe-inner">
                      <Globe
                        ref={globe.globeRef}
                        width={globeSize}
                        height={globeSize}
                        globeImageUrl="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=="
                        backgroundColor="rgba(0,0,0,0)"
                        showAtmosphere={true}
                        atmosphereColor="rgba(255,120,120,0.35)"
                        atmosphereAltitude={0.18}
                        polygonsData={globe.polygonData}
                        polygonAltitude={globe.getPolygonAltitude}
                        polygonCapColor={globe.getPolygonCapColor}
                        polygonSideColor={globe.getPolygonSideColor}
                        polygonStrokeColor={globe.getPolygonStrokeColor}
                        polygonLabel={globe.getPolygonLabel}
                        polygonsTransitionDuration={400}
                        onPolygonHover={globe.setHoverPolygon}
                        onPolygonClick={globe.handlePolygonClick}
                        onGlobeReady={globe.handleGlobeReady}
                      />
                    </div>
                  </div>
                </div>

                <div className="hero-cta-actions mt-5 animate__animated animate__fadeInUp animate__delay-1s">
                  <div className="country-filter-wrap">
                    <p className="filter-title">Negara Populer untuk Study Abroad:</p>

                    <div className="filter-buttons">
                      {defaultCountries.map((country) => {
                        const isActive = globe.activeCountry?.isoNum === country.isoNum;

                        return (
                          <div key={country.slug} className="filter-btn-item">
                            <button
                              onClick={() => globe.setActiveCountry(country)}
                              className={`filter-btn ${isActive ? "active" : ""}`}
                            >
                              {country.label}
                            </button>
                          </div>
                        );
                      })}

                      {!showAllCountries && (
                        <div className="filter-btn-item">
                          <button
                            onClick={() => setShowAllCountries(true)}
                            className="filter-btn filter-show-all"
                          >
                            Lihat Semua
                          </button>
                        </div>
                      )}

                      <div className={`collapsible-countries-wrapper ${showAllCountries ? "expanded" : ""}`}>
                        {collapsibleCountries.map((country) => {
                          const isActive = globe.activeCountry?.isoNum === country.isoNum;

                          return (
                            <div key={country.slug} className="filter-btn-item">
                              <button
                                onClick={() => globe.setActiveCountry(country)}
                                className={`filter-btn ${isActive ? "active" : ""}`}
                              >
                                {country.label}
                              </button>
                            </div>
                          );
                        })}
                      </div>

                      {showAllCountries && (
                        <div className="filter-btn-item show-toggle">
                          <button
                            onClick={() => setShowAllCountries(false)}
                            className="filter-btn filter-show-all"
                          >
                            Tutup
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="hero-stats">
                    <div className="hero-stats-grid d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start gap-3 gap-md-4">
                      {CREDIBLE_STATS.map((stat, id) => (
                        <div key={id} className="stat-box text-start">
                          <span className="stat-num d-block fw-bold">{stat.title}</span>
                          <span className="stat-desc text-white d-block" style={{ fontSize: '0.85rem' }}>{stat.subTitle}</span>
                        </div>
                      ))}
                    </div>
                    <div className="nominee">
                      <div>
                        <img
                          src="/assets/img/slide/home/pieoneer.webp"
                          alt="niec-pieoneer"
                          className="img-fluid"
                        />
                      </div>
                      <div>
                        <a href="https://muri.org/Website/Rekor_detail/tes-potensi-diri-dengan-metode-mbti-oleh-peserta-terbanyak" target="_blank" rel="noopener noreferrer">
                          <img
                            src="/assets/img/slide/home/muri.webp"
                            alt="niec-muri"
                            className="img-fluid"
                          />
                        </a>
                      </div>
                      <IASBadge />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ================================================ */}
        {/* SECTION: Mengapa Pilih Kami                     */}
        {/* ================================================ */}
        <section className="why-section-new">
          <div className="container">
            <div className="row justify-content-center mb-5 animate__animated animate__fadeIn">
              <div className="col-lg-8 text-center">
                <div className="why-badge">Core Values</div>
                <h2 className="why-main-title">Kenapa Harus <span className="text-red-accent">NIEC?</span></h2>
                <div className="why-title-separator">
                  <span></span>
                  <i className="bi bi-star-fill"></i>
                  <span></span>
                </div>
              </div>
            </div>
            <div className="row g-4 justify-content-center">
              {WHY_CHOOSE_US.map((item, id) => (
                <div key={id} className="col-12 col-sm-6 col-lg-3 d-flex animate__animated animate__fadeInUp" style={{ animationDelay: `${id * 0.1}s` }}>
                  <WhyCard {...item} index={id} />
                </div>
              ))}
            </div>
          </div>
        </section>




        {/* ================================================ */}
        {/* SECTION: STARTS Class                           */}
        {/* ================================================ */}
        <section id="starts" className="starts-section-premium">
          <div className="starts-bg-glow"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <div className="starts-content-box animate__animated animate__fadeInLeft">
                  <div className="starts-badge-premium">
                    <i className="bi bi-star-fill"></i>
                    <span>Program Unggulan</span>
                  </div>

                  <h2 className="starts-premium-title">
                    <span className="text-white">STARTS</span> <span className="text-yellow-accent">: Study Abroad</span>
                    <br />
                    <span className="text-white-dim">Preparation Class</span>
                  </h2>

                  <div className="starts-accent-divider"></div>

                  <p className="starts-premium-intro">
                    Persiapkan dirimu menghadapi tantangan studi global dengan mentor berpengalaman.
                    Benefit seumur hidup sebagai prioritas member NIEC.
                  </p>

                  <div className="starts-benefits-premium-grid">
                    {STARTS_BENEFITS.map((benefit, id) => (
                      <div key={id} className="benefit-premium-item">
                        <div className="benefit-icon-box">
                          <i className="bi bi-patch-check-fill"></i>
                        </div>
                        <span>{benefit}</span>
                      </div>
                    ))}
                  </div>

                  <div className="mt-5">
                    <a
                      href="https://superstudent.niecindonesia.com/"
                      className="btn-premium-starts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="btn-text">Ikuti Starts Class Sekarang</span>
                      <span className="btn-icon">
                        <i className="bi bi-arrow-right-circle-fill"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 position-relative animate__animated animate__fadeInRight">
                <div className="starts-visual-container">
                  <div className="starts-image-frame">
                    <img
                      src="assets/img/slide/home/church.webp"
                      alt="Study Abroad Background"
                      className="img-fluid starts-premium-img"
                    />
                    <div className="starts-image-overlay-premium"></div>
                  </div>

                  {/* Decorative Floating Elements */}
                  <div className="floating-card-starts card-1">
                    <i className="bi bi-globe-americas"></i>
                    <div>
                      <h6>Global Network</h6>
                      <p>20+ Countries</p>
                    </div>
                  </div>

                  <div className="floating-card-starts card-2">
                    <i className="bi bi-shield-check"></i>
                    <div>
                      <h6>Guaranteed Support</h6>
                      <p>Lifetime Benefit</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="consultation" className="consultation-section">
          <div className="container">
            <div className="consultation-wrapper animate__animated animate__fadeIn">
              <div className="card-programs-header-left">
                <span className="card-programs-eyebrow-new">Mulai Perjalananmu</span>
                <h2 className="card-programs-heading-new">
                  Sesuaikan Jadwal <span className="card-programs-accent-new">Konsultasi Online</span>
                </h2>
                <p className="card-programs-subtitle-new mb-3">
                  Temui tim kami secara online untuk merencanakan studi dan karier
                  internasionalmu dengan strategi yang tepat, arahan profesional,
                  serta jadwal konsultasi fleksibel yang disesuaikan dengan
                  kebutuhan dan rencana masa depanmu.
                </p>
                <button
                  className="btn-consultation"
                  onClick={() => setOpen(true)}
                >
                  <span>Mulai Konsultasi</span>
                  <span className="btn-icon">
                    <i className="bi bi-arrow-right-circle-fill"></i>
                  </span>
                </button>
              </div>
              <div className="mx-auto">
                <img src="/assets/img/slide/home/consultant.webp" alt="niec-consultant" className="img-consultant img-fluid" />
              </div>
            </div>
          </div>
          <ConsultationModal
            open={open}
            onClose={() => setOpen(false)}
          />
        </section>

        {/* ================================================ */}
        {/* SECTION: Kartu Program — Horizontal Showcase     */}
        {/* ================================================ */}
        <section id="card-programs" className="card-programs-section">
          <div className="container">
            <div className="card-programs-header-new animate__animated animate__fadeIn">
              <div className="card-programs-header-left">
                <span className="card-programs-eyebrow-new">Solusi Pendidikan</span>
                <h2 className="card-programs-heading-new">
                  Layanan <span className="card-programs-accent-new">Unggulan</span>
                </h2>
                <p className="card-programs-subtitle-new">
                  Pilih program yang sesuai dengan tujuan akademik dan karir internasionalmu.
                </p>
              </div>

              <div className="card-programs-nav-new">
                <button
                  className="card-programs-btn-new"
                  onClick={() => {
                    const track = document.querySelector(".card-programs-track-wrapper");
                    if (track) track.scrollBy({ left: -350, behavior: "smooth" });
                  }}
                  aria-label="Previous"
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button
                  className="card-programs-btn-new"
                  onClick={() => {
                    const track = document.querySelector(".card-programs-track-wrapper");
                    if (track) track.scrollBy({ left: 350, behavior: "smooth" });
                  }}
                  aria-label="Next"
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="card-programs-track-wrapper">
            <div className="card-programs-track">
              {CARD_HERO_DATA.map((item, id) => (
                <div
                  key={id}
                  className="card-prog-item"
                >
                  <div
                    className="card-prog-bg"
                    style={{ backgroundImage: `url(${item.img})` }}
                  />
                  <div className="card-prog-gradient" />

                  <div className="card-prog-body">
                    <span className="card-prog-badge">{item.category}</span>
                    <h3 className="card-prog-title">{item.cardTitle}</h3>
                    <p className="card-prog-desc">{item.description}</p>
                    <a href={item.ctaLink} className="card-prog-cta">
                      {item.ctaLabel}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="container">
            <div className="card-programs-progress">
              <div className="cp-progress-track">
                <div className="cp-progress-fill" id="cpProgFill" />
              </div>
            </div>
          </div>
        </section>

        {/* ================================================ */}
        {/* SECTION: Testimoni Alumni                        */}
        {/* ================================================ */}
        <section id="testimonials" className="testi-section-new">
          <div className="container">
            <div className="testi-header-modern animate__animated animate__fadeIn">
              <span className="testi-eyebrow-modern">Alumni Kami</span>
              <h2 className="testi-title-modern">Kisah Nyata, <span className="testi-accent">Impian Nyata</span></h2>
              <p className="testi-subtitle-modern">Ribuan alumni NIEC telah membuktikan perjalanan mereka ke kampus terbaik dunia.</p>
              <div className="testi-header-line"></div>
            </div>

            <div className="testi-slider-container">
              <Slider {...testimonialSettings}>
                {TESTIMONIALS.map((item, id) => (
                  <div key={id} className="testi-slide-item">
                    <div className="tcard-modern">
                      <div className="tcard-photo-wrap-modern">
                        <img src={item.photo} alt={`alumni-niec-${item.name}`} className="tcard-photo-modern" />
                        <div className="tcard-location-badge">{item.location}</div>
                      </div>
                      <div className="tcard-body-modern">
                        <div className="tcard-stars-modern">
                          <i className="bi bi-star-fill"></i>
                          <i className="bi bi-star-fill"></i>
                          <i className="bi bi-star-fill"></i>
                          <i className="bi bi-star-fill"></i>
                          <i className="bi bi-star-fill"></i>
                        </div>
                        <div className="tcard-quote-icon">
                          <i className="bi bi-quote"></i>
                        </div>
                        <p className="tcard-text-modern">"{item.text}"</p>
                        <div className="tcard-info-modern">
                          <h5 className="tcard-name-modern">{item.name}</h5>
                          <p className="tcard-inst-modern">{item.institution}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>

        <section id="article">
          <div className="art-section">

            {/* Header */}
            <div className="art-header">
              <div className="art-header-left">
                <div className="art-eyebrow">Wawasan &amp; Inspirasi</div>
                <h2 className="art-title">Baca <span>Artikel</span> Terbaru</h2>
              </div>
              <a href="/artikel" className="art-see-all">
                Lihat Semua
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            {/* Scroll track */}
            <div className="art-scroll-outer">
              <div className="art-track-wrap" ref={artTrackRef}>
                <div className="art-track">
                  {dataArtikel.map((artikel, id) => (
                    <div key={id} className="art-card">
                      <div className="art-card-img">
                        <img
                          src={artikel.image}
                          alt={`niec-article-${artikel.judul}`}
                          loading="lazy"
                        />
                        <span className="art-card-badge">Artikel</span>
                      </div>
                      <div className="art-card-body">
                        <div className="art-card-meta">
                          <i className="bi bi-person-circle" style={{ fontSize: "12px" }}></i>
                          <span>NIEC Indonesia</span>
                          <div className="art-card-meta-dot" />
                          <i className="bi bi-clock" style={{ fontSize: "12px" }}></i>
                          <span>5 menit baca</span>
                        </div>
                        <h3 className="art-card-title">{artikel.judul}</h3>
                        <div className="art-card-divider" />
                        <p className="art-card-excerpt">
                          {truncateTextFromHtml(artikel.isi, 150)}
                        </p>
                        <Link
                          to={`/artikeldetail/${artikel.slug}`}
                          className="art-card-cta"
                        >
                          Selengkapnya
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M5 12h14M12 5l7 7-7 7"
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Nav: dots + arrows */}
            <div className="art-nav">
              <div className="art-dots-container">
                <div className="art-dots">
                  {[...Array(5)].map((_, id) => (
                    <button
                      key={id}
                      className={`art-dot${id === 0 ? " active" : ""}`}
                      onClick={() => {
                        // Jika artikel banyak, klik dot ke-i akan scroll ke kelipatan index tersebut
                        const targetIdx = Math.round((id / 5) * dataArtikel.length);
                        scrollToCard(targetIdx);
                      }}
                      aria-label={`Halaman ${id + 1}`}
                    />
                  ))}
                </div>
                <div className="art-dot-progress-track">
                  <div className="art-dot-progress-fill" id="artDotFill" />
                </div>
              </div>
              <div className="art-arrows">
                <button
                  id="artBtnPrev"
                  className="art-arrow"
                  onClick={() => scrollToCard(artActiveRef.current - 1)}
                  aria-label="Sebelumnya"
                  disabled
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button
                  id="artBtnNext"
                  className="art-arrow"
                  onClick={() => scrollToCard(artActiveRef.current + 1)}
                  aria-label="Berikutnya"
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>

          </div>
        </section>

        {/* ================================================ */}
        {/* SECTION: Super Student App                      */}
        {/* ================================================ */}
        <section id="super-student">
          <div className="super-bg">
            <div className="container d-flex justify-content-center">
              <div className="row flex-column-reverse flex-md-row gap-3 gap-md-0 super-wrapper">
                <div className="col-12 col-md-4">
                  <img
                    src="assets/img/slide/home/super-mock-up.webp"
                    alt="super-student-app-preview-on-mobile"
                    className="img-fluid super-mock-up"
                  />
                  <div className="super-shadow" />
                </div>
                <div className="col-12 col-md-4 text-center text-md-start">
                  <div>
                    <span>
                      <h3>JELAJAHI</h3>
                      <h3>LEBIH DEKAT</h3>
                    </span>
                    <span>
                      <h3>KAMPUS</h3>
                      <h3>LUAR NEGERI</h3>
                    </span>
                  </div>
                  <div className="mb-2">
                    <h5>Download <span>Super Student</span></h5>
                    <h5>Sekarang</h5>
                  </div>
                  <div className="store-wrapper">
                    <p className="available">Available on :</p>
                    <a
                      href="https://play.google.com/store/apps/details?id=io.niec.superstudent&hl=en&gl=US"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/img/slide/home/play-store.webp"
                        alt="download-super-student-on-google-play"
                        className="img-fluid store"
                      />
                    </a>
                    <a
                      href="https://apps.apple.com/us/app/super-student/id1614354792"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/img/slide/home/app-store.webp"
                        alt="download-super-student-on-app-store"
                        className="img-fluid store"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-12 col-md-4 super-fade" />
              </div>
            </div>
          </div>
        </section>

      </main>
    </div>
  );
};

export default Home;